module.exports = __webpack_public_path__ + "img/search-icon-gray.7070cc66.svg";